var _path, _path2, _circle, _path3, _path4, _path5, _path6, _g, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBl1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2018,
    height: 2500,
    viewBox: "7 7 619 767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 5,
    d: "M59.5 9.5h514c27.615 0 50 22.387 50 50v662c0 27.615-22.385 50-50 50h-514c-27.613 0-50-22.385-50-50v-662c0-27.615 22.385-50 50-50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C24",
    d: "M81.5 51.5h470c16.569 0 30 13.433 30 30v304c0 16.569-13.431 30-30 30h-470c-16.567 0-30-13.431-30-30v-304c0-16.569 13.431-30 30-30z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 557.5,
    cy: 177.5,
    r: 34
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M429.5 273.5l4 6m-10-2l4 6m28-30l4 6m4-12l4 6m-359 82l4 4m-9 4l4 4m-20 22l4 2m-6 8h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M149.5 107.5c-20 4-18 8-40 44-6 8-4 2-10 10-4 6-8 8-14 12-4 2-2 8 12 0-1.333 2.667-3.333 5.334-6 8-8 8 10 12 18 2 4-4 8-6 8-14 0-4 20-18 36-38l-4-24zM237.5 137.5c2 14 6 16 20 8 4-2 6 0 8-2s6-10 8-12c2-4 12-2 12-12 0-46-50-40-58-8v30h12l-2-4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M229.5 109.5c-26-18-26-18-90-4l8 32c14 0 26-4 36-6-6.666 4-12.666 6.667-18 8-18 68-10 86-4 82h74v-30c2.667-14.666 4-31.333 4-50l-10-32zM179.5 287.5c2 14 6 30 12 40-14-4-44 6-70 20l-16 22c132-10 134 12 126-102l-52 20zM237.5 249.5c12 4 54 8 84 8 8 12 60 12 98 12l14-14c-96-38-112-46-116-42-16-10-42-14-62-18l-18 54z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M161.5 221.5c-10 2 10 84 20 76l52-18v-26h8l20-56c2-4-4-6-30-8l-70 32zM405.5 263.5c4 16 14 26 28 16l32-26c8-6 8-12-8-8-10 2-28 4-48 4l-4 14zM133.5 343.5c-10-14-22-16-30 2-20 24-16 28-18 40 0 6 6 6 10 4 6-4 14-16 30-24l8-22z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M417.5 495.5v-20c0-32-24-32-36-32h-46v90h48c32 0 34-22 34-38zm-58 16v-46h24c4 0 10 0 10 14v16c0 6 0 16-14 16h-20zM129.5 513.5v-10c0-7.73-6.268-14-14-14h-6c11.046 0 20-9.85 20-22v-2c0-12.148-10.745-22-24-22h-52v90h48c16 0 28-8 28-20zm-52-52h22a6 6 0 0 1 6 6v5a6 6 0 0 1-6 6h-22v-17zm0 52v-17h22a6 6 0 0 1 6 6v5a6 6 0 0 1-6 6h-22zM547.5 513.5c-14 0-16 0-16-10h-24c0 14 0 32 40 32 38 0 38-22 38-30s0-26-30-26c-6 0-24 0-24-8s4-8 14-8 14 0 14 8h22c0-28-8-28-38-28-32 0-36 8-36 28 0 6 0 26 32 26 6 0 22 0 22 8s-4 8-14 8zM495.5 513.5h-42v-16h38v-18h-38v-16h42v-20h-66v90h66zM99.5 551.5h-46v176h112v-42h-66zM337.5 551.5c-76 0-84 26-84 88s0 90 84 90c76 0 76-20 76-90s0-88-76-88zm-2 140c-32 0-32-6-32-52s0-48 32-48 32 2 32 48 0 52-32 52zM541.5 551.5h-72l-52 176h48l40-140 40 140h48zM185.5 551.5h48v176h-48zM219.5 503.5v-60h-24v58c0 8 0 12-12 12h-6c-12 0-12-4-12-12v-58h-24v60c0 16 0 32 39 32s39-16 39-32zM257.5 465.5l26 68h40v-90h-24v68l-26-68h-40v90h24z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M335.5 661.5h50v-36h-50v36zm114 36h100v-34h-100v34z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M333.5 629.5h100v-22h-100v22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBl1);
export default __webpack_public_path__ + "static/media/bl1.118e3835327a860c18752797d5fe7702.svg";
export { ForwardRef as ReactComponent };